import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-39daa3d1")

_pushScopeId("data-v-39daa3d1")
const _hoisted_1 = { class: "jira_page" }
const _hoisted_2 = { class: "fixed" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 跳转客户 Jira Filter Dashboard ")
const _hoisted_5 = { class: "right" }
const _hoisted_6 = {
  key: 1,
  class: "jira_list"
}
const _hoisted_7 = { class: "date" }
const _hoisted_8 = { class: "popup_title" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_van_icon = _resolveComponent("van-icon")
  const _component_van_button = _resolveComponent("van-button")
  const _component_van_dropdown_item = _resolveComponent("van-dropdown-item")
  const _component_van_dropdown_menu = _resolveComponent("van-dropdown-menu")
  const _component_van_loading = _resolveComponent("van-loading")
  const _component_van_popup = _resolveComponent("van-popup")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", {
          class: "left",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openFilter && _ctx.openFilter(...args)))
        }, [
          _createVNode(_component_van_icon, { name: "share-o" }),
          _hoisted_4
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_van_button, {
            icon: "replay",
            round: "",
            type: "primary",
            class: 
              _ctx.state.refreshing ? 'refreshBtn animation-rotating' : 'refreshBtn'
            ,
            disabled: _ctx.state.refreshing,
            size: "mini",
            onClick: _ctx.onRefresh
          }, null, 8, ["class", "disabled", "onClick"]),
          _createVNode(_component_van_button, {
            icon: "plus",
            round: "",
            type: "primary",
            class: "btn",
            size: "mini",
            onClick: _cache[2] || (_cache[2] = 
              () => _ctx.openUrl('https://jira.agoralab.co/projects/CSD/issues')
            )
          })
        ])
      ]),
      _createVNode(_component_van_dropdown_menu, {
        "active-color": "#2c90f3",
        "z-index": "1",
        duration: "0.2"
      }, {
        default: _withId(() => [
          _createVNode(_component_van_dropdown_item, {
            modelValue: _ctx.state.stage,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.stage = $event)),
            options: _ctx.stageOpts
          }, null, 8, ["modelValue", "options"]),
          _createVNode(_component_van_dropdown_item, {
            modelValue: _ctx.state.priority,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.priority = $event)),
            options: _ctx.priorityOpts,
            "title-class": "priority-option"
          }, null, 8, ["modelValue", "options"]),
          _createVNode(_component_van_dropdown_item, {
            modelValue: _ctx.state.vid,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.vid = $event)),
            options: _ctx.state.vidOpts,
            onChange: _ctx.onVidChange
          }, null, 8, ["modelValue", "options", "onChange"])
        ]),
        _: 1
      })
    ]),
    (_ctx.state.loading)
      ? (_openBlock(), _createBlock(_component_van_loading, {
          key: 0,
          type: "spinner",
          size: "40",
          style: {"margin-top":"40px"}
        }))
      : (_openBlock(), _createBlock("ul", _hoisted_6, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data, (item) => {
            return (_openBlock(), _createBlock("li", {
              key: item.key
            }, [
              _createVNode("div", {
                class: "key",
                onClick: ($event: any) => (_ctx.openJira(item.key))
              }, _toDisplayString(item.key), 9, ["onClick"]),
              _createVNode("div", {
                class: "title",
                onClick: ($event: any) => (_ctx.openTitle(item.fields.summary))
              }, _toDisplayString(item.fields.summary), 9, ["onClick"]),
              _createVNode("img", {
                class: "icon",
                src: _ctx.priorityIconMap[item.fields?.priority?.name]
              }, null, 8, ["src"]),
              _createVNode("div", _hoisted_7, _toDisplayString(item.fields.created?.slice(5, 10)), 1)
            ]))
          }), 128))
        ])),
    _createVNode(_component_van_popup, {
      show: _ctx.state.showPopup,
      "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => (_ctx.state.showPopup = $event)),
      onClose: _ctx.closePopup
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_8, _toDisplayString(_ctx.state.title), 1)
      ]),
      _: 1
    }, 8, ["show", "onClose"])
  ]))
})